import { faClose, FaIcon, faIdBadge } from '@/lib/fa'
import { driversRoutesMap } from '@/modules/drivers/routes-config'
import React from 'react'
import { generatePath } from 'react-router-dom'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import BusinessTripHeaderFields from '../components/BusinessTripHeaderFields'

const AddBusinessTipNavbar = ({
  companyId,
  driverId,
  from,
  to,
  history,
  driverName,
  driverCount = 1,
  backPath = null,
  destinationCountry = null,
  onDestinationCountryChange = null,
  calculationDate = null,
  onCalculationDateChange = null,
}) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-py-4">
      <div className="tw-ml-4 tw-flex tw-flex-col tw-gap-3">
        <div className="tw-flex tw-items-center tw-gap-2">
          <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
            {t('businessTrip.add')}
            {driverCount > 1
              ? ` (${driverCount} ${t('driverModule.drivers-count')})`
              : ''}
          </p>
          {driverName && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm">
              <div className="tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-base-300 tw-px-1">
                <FaIcon icon={faIdBadge} className="tw-cursor-pointer" />
                <span>{driverName}</span>
              </div>
            </div>
          )}
        </div>

        {onDestinationCountryChange && onCalculationDateChange && (
          <BusinessTripHeaderFields
            companyId={companyId}
            country={destinationCountry}
            onCountryChange={onDestinationCountryChange}
            settlementDate={calculationDate}
            onSettlementDateChange={onCalculationDateChange}
          />
        )}
      </div>

      <div
        onClick={() => {
          const resolvedBackPath =
            backPath ||
            generatePath(driversRoutesMap.driverBusinessTrips, {
              companyId,
              driverId,
              from,
              to,
            })
          history.push(resolvedBackPath)
        }}
        className="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-4"
      >
        <p className="tw-text-medium tw-m-0 tw-text-red-500">
          {t('common.close')}
        </p>
        <FaIcon
          icon={faClose}
          className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer tw-text-red-500"
        />
      </div>
    </div>
  )
}

export default AddBusinessTipNavbar
